// Clear the browser session immediately; revoke the captured token separately.
async function logoutSession({ token, revoke = true, clear, post }) {
  clear();
  if (!token || !revoke) {
    return false;
  }

  try {
    await post('/auth/logout', null, {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 5000,
      skipAuthLogout: true,
    });
    return true;
  } catch {
    // Offline or expired tokens must not keep a browser session signed in.
    return false;
  }
}

module.exports = { logoutSession };
